export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-address-book-cc393e63b29b23695a2ea429bed2f251.svg";